import React from 'react';

import { YouTubeFollowButton } from './YouTubeFollowButton';

export const VideoArticleYouTubeCTA: React.FC = () => {
  return (
    <div className="video-article-youtube-cta my-6 flex flex-col gap-4 rounded-lg border border-blue-600 bg-blue-50 p-5 shadow-sm md:flex-row md:items-center md:justify-between md:gap-6">
      <div>
        <h3 className="mb-1.5 text-lg font-bold leading-snug text-gray-900">Don&apos;t Miss a Video</h3>
        <p className="m-0 max-w-2xl text-[0.95rem] leading-relaxed text-gray-600">
          Subscribe to Benzinga on YouTube for daily market coverage, stock analysis, and interviews with the analysts
          and traders who move markets.
        </p>
      </div>
      <YouTubeFollowButton className="shrink-0" variant="subscribe" />
    </div>
  );
};
